import * as React from 'react';
// import './Content.css';
import Header from './Header';
import "../styles/nav.css";
import Tech from './Tech';
import About from './About';
import Projects from './Projects';
import Contact from './Contact';

const Content = () => {
  return (
    <div >
      <Header />
      {/* <Title /> */}
       <About />
      <Tech />
      <Projects /> 
      {/* <About /> */}
      <Contact />
    </div>
  );
}

export default Content;
